import { Values } from '@lib/interfaces/form';

// Merges freshly-fetched defaultValues into the current form values, but keeps
// the user's own value for any field RHF's dirtyFields marks as touched. Used
// when defaultValues changes mid-edit (e.g. a background job updates the
// record being edited) so the refresh doesn't clobber an in-progress edit.
export default function mergeDefaultValuesPreservingDirtyFields(
  currentValues: Values,
  nextDefaultValues: Values,
  dirtyFields: Record<string, unknown>,
): Values {
  const merged: Values = { ...currentValues, ...nextDefaultValues };
  Object.keys(dirtyFields).forEach((key) => {
    if (dirtyFields[key]) {
      merged[key] = currentValues[key];
    }
  });
  return merged;
}
